// Keep Shopify's native quantity component authoritative for validation and checkout.
class LevayoQuantity extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.product-details');
    if (!this.scope) return;
    this.input = this.querySelector('input');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-step]');
      if (!button || !this.nativeInput) return;
      const name = button.dataset.step === '1' ? 'plus' : 'minus';
      this.nativeInput.closest('quantity-selector-component').querySelector(`[name="${name}"]`)?.click();
      queueMicrotask(() => this.sync());
    }, options);
    this.input.addEventListener('change', (event) => {
      if (!this.nativeInput) return;
      this.nativeInput.value = this.input.value;
      this.nativeInput.closest('quantity-selector-component').setQuantity(event);
      this.nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
      queueMicrotask(() => this.sync());
    }, options);
    this.scope.addEventListener('change', (event) => {
      if (!this.contains(event.target)) queueMicrotask(() => this.sync());
    }, options);
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'value'] });
    this.sync();
  }
  sync() {
    this.nativeInput = this.scope.querySelector('product-form-component quantity-selector-component input[name="quantity"]');
    if (!this.nativeInput) return;
    this.hidden = false;
    this.scope.classList.add('lv-quantity-ready');
    if (this.input.value !== this.nativeInput.value) this.input.value = this.nativeInput.value;
    for (const attr of ['min', 'max', 'step']) {
      const value = this.nativeInput.getAttribute(attr);
      if (value === null) {
        if (this.input.hasAttribute(attr)) this.input.removeAttribute(attr);
      } else if (this.input.getAttribute(attr) !== value) this.input.setAttribute(attr, value);
    }
    if (this.input.disabled !== this.nativeInput.disabled) this.input.disabled = this.nativeInput.disabled;
    for (const button of this.querySelectorAll('[data-step]')) {
      const name = button.dataset.step === '1' ? 'plus' : 'minus';
      const nativeButton = this.nativeInput.closest('quantity-selector-component').querySelector(`[name="${name}"]`);
      const disabled = this.nativeInput.disabled || Boolean(nativeButton?.disabled);
      if (button.disabled !== disabled) button.disabled = disabled;
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.scope?.classList.remove('lv-quantity-ready');
  }
}
if (!customElements.get('levayo-quantity')) customElements.define('levayo-quantity', LevayoQuantity);
